import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  selectors,
  ASSET_CLASSES,
  RISK_WEIGHTED_APPROACH,
  updateLeverageSettings,
  updateAssetClassOptions,
  AssetClassOptions,
  MarginOptions,
  updateHistoricalStep,
  fetchHistoricalStep,
  updateMRR,
} from 'state';
import { EditableTable } from 'reusable';
import { LoadingScreen, PercentInput } from 'components';
import {
  Button,
  Card,
  InputNumber,
  Popover,
  Table,
  Tooltip,
  Typography,
} from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

type State = {
  [type: string]: MarginOptions;
};
const MinimumReserveRequirement: React.FC = () => {
  const dispatch = useDispatch();

  const session = useSelector(selectors.activeSession);

  const [mrr, setMrr] = useState<number>(session.mrr);

  return (
    <div>
      <div style={{ position: 'relative' }}>
        <Typography.Title level={4} style={{ display: 'inline-block' }}>
          Minimum Reserve Requirement
        </Typography.Title>
      </div>

      <Card>
        <div style={{ display: 'flex', gap: 10 }}>
          <Typography.Text type={'secondary'} style={{ marginTop: '5px' }}>
            MRR:
          </Typography.Text>
          <InputNumber
            style={{ width: '75px' }}
            placeholder={'Percent'}
            value={mrr}
            // formatter={value =>
            //   `${value}` + ' s.'
            // }
            // parser={(value = '') =>
            //   value.replace(/[^0-9]/g, '')
            // }
            step={0.01}
            min={0}
            max={1}
            formatter={value => {
              const nr = Number(value) || 0;
              return `${Math.round(nr * 100)}%`;
            }}
            parser={value => {
              const parsedValue = `${value?.replaceAll('%', '')}`;
              const nr = Number(parsedValue);
              if (!isNaN(nr)) {
                return Number((nr / 100).toFixed(2));
              }
              return 0;
            }}
            onChange={value => {
              if (value !== undefined) {
                setMrr(value);
              }
            }}
          />
          <Button
            onClick={() => {
              dispatch(
                updateMRR({
                  session_id: session.id,
                  mrr: mrr,
                })
              );
            }}
          >
            Save
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default MinimumReserveRequirement;
